import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EvaluationCampsModel } from './EvaluationCampsModel';
@Injectable({
  providedIn: 'root'
})
export class EvaluationCampService {

  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 

 GetAllByCampIdId(CampId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}EvaluationCamp/GetAllByCampIdId/${CampId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

insert(payload: EvaluationCampsModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}EvaluationCamp/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}


}
